// ISO 3166-1 alpha-2 country code to population (2023 estimates, rounded)
// Source: World Bank, UN, Wikipedia
export const countryPopulations = {
  AF: 41128771, // Afghanistan
  AL: 2837743, // Albania
  DZ: 44903225, // Algeria
  AS: 44273, // American Samoa
  AD: 79824, // Andorra
  AO: 35588987, // Angola
  AI: 15337, // Anguilla
  AQ: 0, // Antarctica
  AG: 94071, // Antigua and Barbuda
  AR: 45773885, // Argentina
  AM: 2780469, // Armenia
  AW: 106537, // Aruba
  AU: 26483451, // Australia
  AT: 8917205, // Austria
  AZ: 10301142, // Azerbaijan
  BS: 412623, // Bahamas
  BH: 1485509, // Bahrain
  BD: 173977000, // Bangladesh
  BB: 281635, // Barbados
  BY: 9452411, // Belarus
  BE: 11686148, // Belgium
  BZ: 405272, // Belize
  BJ: 13683505, // Benin
  BM: 63973, // Bermuda
  BT: 782455, // Bhutan
  BO: 12457436, // Bolivia
  BQ: 26673, // Bonaire, Sint Eustatius and Saba
  BA: 3216052, // Bosnia and Herzegovina
  BW: 2626785, // Botswana
  BV: 0, // Bouvet Island
  BR: 216422446, // Brazil
  IO: 3000, // British Indian Ocean Territory
  BN: 452524, // Brunei
  BG: 6649297, // Bulgaria
  BF: 23663695, // Burkina Faso
  BI: 13605536, // Burundi
  KH: 16944827, // Cambodia
  CM: 28867964, // Cameroon
  CA: 39391327, // Canada
  CV: 598682, // Cape Verde
  KY: 71259, // Cayman Islands
  CF: 5633412, // Central African Republic
  TD: 18526409, // Chad
  CL: 19629589, // Chile
  CN: 1425671352, // China
  CX: 2072, // Christmas Island
  CC: 596, // Cocos (Keeling) Islands
  CO: 52085168, // Colombia
  KM: 852075, // Comoros
  CG: 6216266, // Congo
  CD: 102262808, // Congo (Democratic Republic)
  CK: 17088, // Cook Islands
  CR: 5223835, // Costa Rica
  CI: 28773018, // Côte d'Ivoire
  HR: 3871833, // Croatia
  CU: 11212043, // Cuba
  CW: 191163, // Curaçao
  CY: 1260135, // Cyprus
  CZ: 10736797, // Czechia
  DK: 5910916, // Denmark
  DJ: 1126535, // Djibouti
  DM: 72628, // Dominica
  DO: 11336032, // Dominican Republic
  EC: 18001000, // Ecuador
  EG: 112716599, // Egypt
  SV: 6336393, // El Salvador
  GQ: 1830430, // Equatorial Guinea
  ER: 3717452, // Eritrea
  EE: 1326535, // Estonia
  SZ: 1209581, // Eswatini
  ET: 126527060, // Ethiopia
  FK: 3500, // Falkland Islands
  FO: 53688, // Faroe Islands
  FJ: 936375, // Fiji
  FI: 5540745, // Finland
  FR: 68473638, // France
  GF: 312948, // French Guiana
  PF: 305892, // French Polynesia
  TF: 400, // French Southern Territories
  GA: 2477967, // Gabon
  GM: 2754967, // Gambia
  GE: 3729505, // Georgia
  DE: 83294633, // Germany
  GH: 34121985, // Ghana
  GI: 33610, // Gibraltar
  GR: 10432481, // Greece
  GL: 56361, // Greenland
  GD: 126183, // Grenada
  GP: 375693, // Guadeloupe
  GU: 171519, // Guam
  GT: 18630573, // Guatemala
  GG: 63434, // Guernsey
  GN: 14538756, // Guinea
  GW: 2230722, // Guinea-Bissau
  GY: 813834, // Guyana
  HT: 11585029, // Haiti
  HM: 0, // Heard Island and McDonald Islands
  VA: 764, // Holy See
  HN: 10522299, // Honduras
  HK: 7496981, // Hong Kong
  HU: 9634644, // Hungary
  IS: 376248, // Iceland
  IN: 1428627663, // India
  ID: 277534122, // Indonesia
  IR: 89172730, // Iran
  IQ: 45504560, // Iraq
  IE: 5203307, // Ireland
  IM: 84971, // Isle of Man
  IL: 9646772, // Israel
  IT: 58870762, // Italy
  JM: 2825544, // Jamaica
  JP: 123294513, // Japan
  JE: 108682, // Jersey
  JO: 11335793, // Jordan
  KZ: 19606633, // Kazakhstan
  KE: 55058465, // Kenya
  KI: 133515, // Kiribati
  KP: 26160821, // Korea (North)
  KR: 51784059, // Korea (South)
  KW: 4420110, // Kuwait
  KG: 7008300, // Kyrgyzstan
  LA: 7648357, // Laos
  LV: 1861365, // Latvia
  LB: 5353930, // Lebanon
  LS: 2330311, // Lesotho
  LR: 5406199, // Liberia
  LY: 6871292, // Libya
  LI: 39391, // Liechtenstein
  LT: 2790965, // Lithuania
  LU: 654768, // Luxembourg
  MO: 695168, // Macao
  MG: 30325783, // Madagascar
  MW: 20931651, // Malawi
  MY: 34308525, // Malaysia
  MV: 521021, // Maldives
  ML: 22968714, // Mali
  MT: 535064, // Malta
  MH: 42516, // Marshall Islands
  MQ: 374087, // Martinique
  MR: 4967318, // Mauritania
  MU: 1273897, // Mauritius
  YT: 350726, // Mayotte
  MX: 128455567, // Mexico
  FM: 115224, // Micronesia
  MD: 3250680, // Moldova
  MC: 36686, // Monaco
  MN: 3456405, // Mongolia
  ME: 626485, // Montenegro
  MS: 4992, // Montserrat
  MA: 37457992, // Morocco
  MZ: 33735321, // Mozambique
  MM: 55777462, // Myanmar
  NA: 2682037, // Namibia
  NR: 12903, // Nauru
  NP: 30425159, // Nepal
  NL: 17564014, // Netherlands
  NC: 289905, // New Caledonia
  NZ: 5228100, // New Zealand
  NI: 7046311, // Nicaragua
  NE: 27232199, // Niger
  NG: 223804632, // Nigeria
  NU: 1949, // Niue
  NF: 2188, // Norfolk Island
  MK: 2083459, // North Macedonia
  MP: 49447, // Northern Mariana Islands
  NO: 5481363, // Norway
  OM: 4734292, // Oman
  PK: 240485658, // Pakistan
  PW: 18024, // Palau
  PS: 5315700, // Palestine
  PA: 4442239, // Panama
  PG: 10623314, // Papua New Guinea
  PY: 6861524, // Paraguay
  PE: 34352719, // Peru
  PH: 117337368, // Philippines
  PN: 47, // Pitcairn Islands
  PL: 41026095, // Poland
  PT: 10343141, // Portugal
  PR: 3250169, // Puerto Rico
  QA: 2820626, // Qatar
  RE: 1012375, // Réunion
  RO: 19042059, // Romania
  // Russia (without North Caucasus)
  RU: 132000000, // Russia (without North Caucasus, approx)
  // North Caucasus republics (approximate populations)
  "RU-CE": 1296000, // Chechnya
  "RU-DA": 3200000, // Dagestan
  "RU-IN": 520000, // Ingushetia
  "RU-SE": 700000, // North Ossetia–Alania
  "RU-KB": 900000, // Kabardino-Balkaria
  "RU-KC": 470000, // Karachay-Cherkessia
  // Synthetic code for Russia (whole)
  "RU-WHOLE": 144444359, // Russia (whole)
  RW: 14274959, // Rwanda
  BL: 9945, // Saint Barthélemy
  SH: 6077, // Saint Helena
  KN: 47506, // Saint Kitts and Nevis
  LC: 180251, // Saint Lucia
  MF: 32293, // Saint Martin
  PM: 5794, // Saint Pierre and Miquelon
  VC: 100969, // Saint Vincent and the Grenadines
  WS: 225681, // Samoa
  SM: 33642, // San Marino
  ST: 231856, // São Tomé and Príncipe
  SA: 37060298, // Saudi Arabia
  SN: 18049223, // Senegal
  RS: 7130576, // Serbia
  SC: 107660, // Seychelles
  SL: 8729935, // Sierra Leone
  SG: 6014723, // Singapore
  SX: 43814, // Sint Maarten
  SK: 5456362, // Slovakia
  SI: 2100111, // Slovenia
  SB: 740424, // Solomon Islands
  SO: 18697972, // Somalia
  ZA: 60414495, // South Africa
  GS: 30, // South Georgia and the South Sandwich Islands
  SS: 11193725, // South Sudan
  ES: 48538785, // Spain
  LK: 21893579, // Sri Lanka
  SD: 48109098, // Sudan
  SR: 632638, // Suriname
  SJ: 3894, // Svalbard and Jan Mayen
  SE: 10612086, // Sweden
  CH: 8796669, // Switzerland
  SY: 23227014, // Syria
  TW: 23887595, // Taiwan
  TJ: 10061624, // Tajikistan
  TZ: 67391582, // Tanzania
  TH: 71801279, // Thailand
  TL: 1403201, // Timor-Leste
  TG: 8919827, // Togo
  TK: 1466, // Tokelau
  TO: 107773, // Tonga
  TT: 1534935, // Trinidad and Tobago
  TN: 12458223, // Tunisia
  TR: 85342787, // Turkey
  TM: 6497161, // Turkmenistan
  TC: 45753, // Turks and Caicos Islands
  TV: 11792, // Tuvalu
  UG: 48582339, // Uganda
  UA: 36744639, // Ukraine
  AE: 9516871, // United Arab Emirates
  GB: 69281437, // United Kingdom
  US: 339996563, // United States
  UM: 300, // United States Minor Outlying Islands
  UY: 3423106, // Uruguay
  UZ: 35228926, // Uzbekistan
  VU: 334506, // Vanuatu
  VE: 33549313, // Venezuela
  VN: 98858943, // Vietnam
  VG: 31396, // Virgin Islands (British)
  VI: 105870, // Virgin Islands (U.S.)
  WF: 11212, // Wallis and Futuna
  EH: 587259, // Western Sahara
  YE: 34449825, // Yemen
  ZM: 20591909, // Zambia
  ZW: 16665409 // Zimbabwe
};
